var breakpoint={xl:{value:"1460px"},lg:{value:"1200px"},md:{value:"992px"},sm:{value:"768px"},xs:{value:"576px"},xxs:{value:"360px"}};var tokens = {breakpoint:breakpoint};

var breakPoint = function (size) { return "@media(min-width: ".concat(size, ")"); };
var layout = {
    grid: {
        width: tokens.breakpoint.xl.value,
        columns: 12,
        gutter: {
            xs: "8px",
            sm: "16px",
            md: "24px",
            lg: "24px",
            xl: "24px",
        },
        margin: {
            xs: "16px",
            sm: "24px",
            md: "32px",
            lg: "32px",
            xl: "32px",
        },
    },
    breakpoints: {
        xxs: tokens.breakpoint.xxs.value,
        xs: tokens.breakpoint.xs.value,
        sm: tokens.breakpoint.sm.value,
        md: tokens.breakpoint.md.value,
        lg: tokens.breakpoint.lg.value,
        xl: tokens.breakpoint.xl.value,
    },
    media: {
        xxs: breakPoint(tokens.breakpoint.xxs.value),
        xs: breakPoint(tokens.breakpoint.xs.value),
        sm: breakPoint(tokens.breakpoint.sm.value),
        md: breakPoint(tokens.breakpoint.md.value),
        lg: breakPoint(tokens.breakpoint.lg.value),
        xl: breakPoint(tokens.breakpoint.xl.value),
    },
};

export { layout as l };
//# sourceMappingURL=layout-98a901d5.js.map
